import React, { Component, useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Cookie from 'js-cookie';
import { updateStoreInfo, WareHouseList,getWareHouseList } from './actions/wareHouseService'
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import Spinner from '../../UIComponents/Spinner/Spinner';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { DatePicker, Space } from 'antd';
import { Select } from 'antd';
import { Switch } from 'antd';
import moment from "moment";
import LZString from 'lz-string';
import dayjs from 'dayjs';
const { Option } = Select;



const StepList = [
  {
    Style: "inprogress",
    Label: "Store Details",
    Index: 1,
    Icon: "fa fa-building"
  },
  {
    Style: "",
    Label: "Landlord Details",
    Index: 2,
    Icon: "fa fa-user"
  },
  {
    Style: "",
    Label: "Property Details",
    Index: 3,
    Icon: "fa fa-globe"
  },
  {
    Style: "",
    Label: "Store User Details",
    Index: 4,
    Icon: "fa fa-user"
  },

];

export default function EditWareHouse() {
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const user = JSON.parse(decompressedData) 
  const userID = user['userId'];

  const storeList = useSelector(state => state?.wareHouse?.WareHouseDetail?.Stores)
  const storeDetails = useSelector(state => state?.wareHouse?.WareHouseDetail);
  const storeType = useSelector(state => state?.wareHouse?.WareHouseDetail?.buildingTypes);
  const StateList = useSelector(state => state?.wareHouse?.WareHouseDetail?.States)
  const ZoneList = useSelector(state => state?.wareHouse?.WareHouseDetail?.Zones)
  const citiesList = useSelector(state => state?.wareHouse?.WareHouseDetail?.cities)
  const StoreLeaderList=useSelector(state=>state?.wareHouse?.WareHouseDetail?.StoreManagerList)
  const StoreOperationalList=useSelector(state=>state?.wareHouse?.WareHouseDetail?.StoreOperationalList)
  const ZonalManagerList=useSelector(state=>state?.wareHouse?.WareHouseDetail?.ZonalManagerList)
  const EditStoreError=useSelector(state=>state?.wareHouse)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [stepCount, setStepCount] = useState(1);
  const [stepFormList, setStepFormList] = useState(StepList)

  const [title, setTitle] = useState('Edit WareHouse');
  const [storeStaus,setStoreStatus]=useState(true);
  const [storeMgrId,setStoreMgrId]=useState(storeDetails?.StoreMgrId)
  const [storeOpRefId,setStoreOpRefId]=useState(storeDetails?.StoreOpRefId)
  const [zoneOpCoachId,setZoneOpCoachId]=useState(storeDetails?.ZoneOpCoachId)
  const [constructionMgrId,setConstructionMgrId]= useState(storeDetails?.ConstructionMgrId)
  const [maintainceLeaderId,setMaintainceLeaderId] =useState(storeDetails?.MaintainceLeaderId)
  const PropertyTypes = useSelector(state => state?.wareHouse?.WareHouseDetails?.propertyTypes)

  const [storeName, setStoreName] = useState(storeDetails?.StoreName);
  const [type, setType] = useState(storeDetails?.BuildingType);
  const [city, setCity] = useState(storeDetails?.StoreCityId);
  const [state, setState] = useState(storeDetails?.StateId);
  const [storeAddress, setStoreAddress] = useState(storeDetails?.StoreAddress);
  const [zone, setZone] = useState(storeDetails?.Zone);
  const [propertyType, setPropertyType] = useState(storeDetails?.PropertyType);
  console.log(propertyType,'propertyType')
  const [landName, setLandName] = useState(storeDetails?.LandLordName);
  const [email, setEmail] = useState(storeDetails?.LandLordEmail);
  const [contactNumber, setContactNumber] = useState(storeDetails?.LandLordContactNumber);
  const [alternateNumber, setAlternateNumber] = useState(storeDetails?.LandLordAltNumber);
  const [leaseStartDate, setLeaseStartDate] = useState(storeDetails?.LeaseStartDate);
  const [leaseEndDate, setLeaseEndDate] = useState(storeDetails?.LeaseEndDate);
  const [storeOpenDate, setStoreOpenDate] = useState(storeDetails?.StoreOpeningDate);
  const [warrentyEndDate, setWarrentyEndDate] = useState(storeDetails?.WarrantyDate);

  const [salesArea, setSalesArea] = useState(storeDetails?.TotalSalesArea);
  const [buildArea, setBuildArea] = useState(storeDetails?.TotalBuitlArea);
  const [carParking, setCarParkng] = useState(storeDetails?.CarParking);
  const [carParkingNumber, setCarParkngNumber] = useState(storeDetails?.NumberOfCarParking);
  const [combined, setCombined] = useState('');
  const [wheelerParking, setWheelerParking] = useState(storeDetails?.NumberOfTwoWheelerParking);
  const [stackParking, setStackParking] = useState(storeDetails?.NumberOfStackParking);
  const [playground, setPlayground] = useState(storeDetails?.PlayGroundConcrete);
  const [size, setSize] = useState(storeDetails?.PlayGroungSize);
  const [playgroundTurf, setPlaygroundTurf] = useState(storeDetails?.PlayGroundTurf);
  const [playgroundTurfSize, setPlaygroundTurfSize] = useState(storeDetails?.PlayGroundTurfSize);

  const [constructionManagerName, setConstructionManagerName] = useState(storeDetails?.constructionMgrName);
  const [constructionManagerNumber, SetConstructionManageNumber] = useState(storeDetails?.counsturtionMgrMobNumber);
  const [storeOperations, setStoreOperations] = useState(storeDetails?.StoreOpRefName);
  const [storeOperationsNumber, setStoreOperationsNumber] = useState(storeDetails?.StoreOpReferentNumber);
  const [storeLeader, setStoreLeader] = useState(storeDetails?.StoreLeader);
  const [storeLeaderNumber, setStoreLeaderNumber] = useState(storeDetails?.MaintainceLeaderNumber);
  const [zoneOperation, setZoneOperation] = useState(storeDetails?.ZoneOpMCoachName);
  const [zoneOperationNumber, setZoneOperationNumber] = useState(storeDetails?.ZoneOpCoachNumber);
  const [maintainceLeader, setMaintainceLeader] = useState(storeDetails?.StoreLeader);
  const [maintainceLeaderNumber, setMaintainceLeaderNumber] = useState(storeDetails?.MaintainceLeaderNumber);
  const [storeImage,setStoreImage]=useState("")
  const [storeFileName,setStoreFileName]=useState("")
  const [storeMaintenanceImage,setStoreMaintenanceImage]=useState("")
  const [storeMaintenanceFileName,setMaintenanceFileName]=useState("")
  const [isSubmit,SetIsSubmit]=useState(false);
  const [gstNumber,setGstNumber] = useState(storeDetails?.GstNumber)

  useEffect(() => {
    setStepFormList(() => _doChangeStep())
  }, [stepCount])


  const _doNavToStoreList = () => {
    dispatch(WareHouseList(true))
    // navigate("/Stores");
  };
  const validateEmail=(email) =>
  {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }
  const _doNextAction = () => {
    SetIsSubmit(true)
    if(storeName?.trim()=='' && stepCount==1)return;
    else if(storeAddress?.trim()=='' && stepCount==1)return;
    // else if(storeImage.trim()=='' && stepCount==1)return;
    // else if(landName.trim()=='' && stepCount==2)return;
    // else if((email.trim()=='' || !validateEmail(email))  && stepCount==2)return;
    // else if((`${contactNumber}`.length<10 ||`${contactNumber}`.length>10) && stepCount==2)return;
    // else if((alternateNumber.length>0 &&alternateNumber.length<10) && stepCount==2)return;
    // else if((`${alternateNumber}`.length<10 ||`${alternateNumber}`.length>10) && stepCount==2)return;
    // else if((`${salesArea}`.length==0 ||`${salesArea}`.length>20) && stepCount==3)return
    // else if((`${buildArea}`.length==0 ||`${buildArea}`.length>20) && stepCount==3)return;
    // else if(carParking.trim()=='' && stepCount==3)return;
    // else if((`${carParkingNumber}`.length==0) && stepCount==3)return;
    // else if(`${wheelerParking}`.length==0 && stepCount==3)return;
    // else if(`${stackParking}`.length==0 && stepCount==3)return;
    // else if(playground.trim()=='' && stepCount==3)return;
    // else if(`${size}`.length==0 && stepCount==3)return;
    // else if(playgroundTurf.trim()=='' && stepCount==3)return;
    // else if(`${playgroundTurfSize}`.length==0 && stepCount==3)return;
    // else if(storeMaintenanceImage=='' && stepCount==3)return;
    setStepCount(stepCount => stepCount + 1)
    SetIsSubmit(false)

  }
  const _doPrevAction = () => {
    setStepCount(stepCount => stepCount - 1)

  }
  const setSelectedMaintenanceFile=(file)=>{
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>{ 
      setMaintenanceFileName(file.name);
      setStoreMaintenanceImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    reader.onerror = error => console.log(error)
  }
  const setSelectedStoreFile=(file)=>{
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>{ 
       setStoreFileName(file.name);
      setStoreImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    reader.onerror = error => console.log(error)
  }

  const _doChangeStep = () => {
    let TempArray = []
    stepFormList.map((element) => {
      if (stepCount > element.Index) {
        element.Style = "completed"
      }
      else if (stepCount == element.Index) {
        element.Style = "inprogress"
      }
      else {
        element.Style = ""
      }
      TempArray.push(element)
    })
    return TempArray;
  }
  const _doSelectVender = (e) => {

  }

  const _doSwitchChange = (e) => {

  }

  const [data, setData] = useState('');


  const handleSubmit = () => {
    SetIsSubmit(true)
    // if((`${storeOperationsNumber}`.length>10 || `${storeOperationsNumber}`.length<10) && stepCount==4)return;
    // else if((`${storeLeaderNumber}`.length>10 || `${storeLeaderNumber}`.length<10) && stepCount==4)return;
    // else if((`${zoneOperationNumber}`.length>10 || `${zoneOperationNumber}`.length<10) && stepCount==4)return;
    // else if((`${maintainceLeaderNumber}`.length>10 || `${maintainceLeaderNumber}`.length<10) && stepCount==4)return;

    // else if()
    const data = {
      fedid:userID,
      store_id: storeDetails.storeId,
      store_type_id: 101,
      store_name:storeName,
      building_type:Number(type),
      property_type:propertyType,
      property_type:propertyType,
      store_state:Number(state),
      store_active:storeStaus?1:0,
      store_city:Number(city),
      store_address:storeAddress,
      store_zone:zone,
      store_costcenter:storeDetails.CostCenter,
      store_notifications:"",
      gst_number:gstNumber,
      landlard_name:landName,
      landlard_email:email,
      landlard_contact_number:contactNumber,
      landlard_alter_contact_number:alternateNumber,
      landlard_lease_start_date:leaseStartDate,
      landlard_lease_end_date:leaseEndDate,
      landlard_store_opening_date:storeOpenDate,
      prop_landlard_warranty_end_date:warrentyEndDate,
      prop_sales_area:salesArea,
      prop_builtup_area:buildArea,
      prop_car_parking:carParking,
      prop_number_of_cars_parking:carParkingNumber,
      // combined,
      prop_number_of_two_wheelars_parking:wheelerParking,
      prop_number_of_stack_parking:stackParking,
      prop_playground_concreate:playground,
      prop_playground_concreate_size:size,
      prop_playground_turf:playgroundTurf,
      prop_playground_turf_size:playgroundTurfSize,
      store_sm_employee_id:storeMgrId,
      store_sm_mobile_number:storeLeaderNumber,
      store_zomc_employee_id:zoneOpCoachId,
      store_zomc_mobile_number:zoneOperationNumber,
      store_cm_employee_id:constructionMgrId,
      store_cm_mobile_number:constructionManagerNumber,
      store_maintaince_lead_employee_id:maintainceLeaderId,
      store_maintaince_lead_mobile_number:maintainceLeaderNumber,
      store_operation_referent_employee_id:storeOpRefId,
      store_operation_referent_mobile_number:storeOperationsNumber,
      filename:storeFileName,
      file:storeImage,
      maintainencechecklistonename:storeMaintenanceFileName,
      maintainencechecklistone:storeMaintenanceImage,
      maintainencechecklisttwo:"",
      maintainencechecklisttwoname:""
    };
    
    dispatch(updateStoreInfo(data))
      };

  const _doSetStoreName = e => setStoreName(e.target.value);
  const _doSelectType = value => setType(value);
  const _doSelectCity = value => setCity(value);
  const _doSelectState=value=>setState(value);
  const _doSelectStoreAddress = e => setStoreAddress(e.target.value.replace(/[^\w\s]/gi, ""));
  const _doSelectZone = value => setZone(value);
  const _doSelectProperty = value => setPropertyType(value);

  const _doSelectEmail = e => setEmail(e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi,""),);
  const _doSelectContactNumber = e => setContactNumber(e.target.value.replace(/[^0-9]/g,''));
  const _doSelectAlternateNumber = e => setAlternateNumber(e.target.value.replace(/[^0-9]/g,''));
  const _doSelectLeaseStartDate = (date, dateString) => setLeaseStartDate(dateString);
  const _doSelectLeaseEndDate = (date, dateString) => setLeaseEndDate(dateString);
  const _doSelectStoreOpenDate = (date, dateString) => setStoreOpenDate(dateString)
  const _doSelectWarrentyEndDate = (date, dateString) => setWarrentyEndDate(dateString);

  const _doSelectSalesArea = e => setSalesArea(e.target.value);
  const _doSelectBuildArea = e => setBuildArea(e.target.value);
  const _doSetCarParking = e => setCarParkng(e.target.value);
  const _doSetCarParkingNumber = e =>setCarParkngNumber(e.target.value);
  const _doSelectCombined = e => setCombined(e.target.value);
  const _doSelectWeelerParking = e => setWheelerParking(e.target.value);
  const _doSelectStackParking = e => setStackParking(e.target.value);
  const _doSelectPlayground = e => setPlayground(e.target.value);
  const _doSelectSize = e => setSize(e.target.value);
  const _doSelectPlaygroundTurf = e => setPlaygroundTurf(e.target.value);
  const _doSelectPlaygroundTurfSize = e => setPlaygroundTurfSize(e.target.value);

  const _doSetManagerName = e => setConstructionManagerName(e.target.value);
  // const _doSelectManagerNumber = e => SetConstructionManageNumber(e.target.value);
  const _doSelectStoreOperations = e => setStoreOperations(e.target.value);
  const _doSelectStoreOperationsNumber = e => setStoreOperationsNumber(e.target.value.replace(/[^0-9]/g,''));
  const _doSelectStoreLeader = e => setStoreLeader(e.target.value);
  const _doSelectStoreLeaderNumber = e => setStoreLeaderNumber(e.target.value.replace(/[^0-9]/g,''));
  const _doSelectZoneOperation = e => setZoneOperation(e.target.value);
  const _doSelectZoneOperationNumber = e => setZoneOperationNumber(e.target.value.replace(/[^0-9]/g,''));
  const _doSelectMaintainceLeader = e => setMaintainceLeader(e.target.value);
  const _doSelectMaintainceLeaderNumber = e => setMaintainceLeaderNumber(e.target.value.replace(/[^0-9]/g,''));
  return (
    <div className="wrapper">
      <Header title={title} />
      <Menu1 />
      {EditStoreError.modalOpen ? (
          <MessageBox
            message={EditStoreError.message}
            onClose={()=>{
              dispatch(WareHouseList(true))
              dispatch(getWareHouseList(userID, '101'))
            }}
            
          />
        ) : null}
  {EditStoreError.loading ? (
              <Spinner/>
            ) : (
      <div className='content-wrapper'>
        <section className='content top-space'>
          <div className="m-panel">
            <div className="m-panel__body pb-10">
              <div className="m-step-form">
                <div className="m-step-form__container">
                  <div className="m-step-form__list">
                    {
                      stepFormList.map((item =>
                        <div className={"m-step-form__item " + item.Style} key={item.Index}>
                          <div className="m-step-form__item--box">
                            <span className={item.Icon}></span>
                          </div>
                          <h5 className="m-step-form__item--lbl">{item.Label}</h5>
                        </div>
                      ))
                    }
                  </div>
                  <div className="m-step-form__content">
                    {
                      stepCount === 1 ?
                        <div className="row m-grid">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label>Building type*</label>
                              <Select className="form-control"
                                showSearch
                                value={type}
                                onChange={_doSelectType}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                  storeType?.map?.((item,i) =>

                                <Option key={i} value={item.id}>{item.value}</Option>
                                  )
                                }
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                <label>Property type*</label>
                                <Select className="form-control"
                                  showSearch
                                  placeholder="-- Please Select --"
                                  onChange={(value) => setPropertyType(value)}
                                  value={propertyType}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    PropertyTypes?.map?.((item, i) =>

                                      <Option key={i} value={item.id}>{item.value}</Option>
                                    )
                                  }
                                </Select>
                                {propertyType == '' && isSubmit == true ? <span className="text-danger">Please Select Property Type</span> : null}
                              </div>
                            </div>
                          {/* <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Store name*</label>
                              <Select className="form-control"
                                showSearch
                                onChange={_doSelectStoreName}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={storeName}
                              > {
                                  storeList?.map?.((item =>
                                    <Option key={item.Value} value={item.Value}>{item.Label}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div> */}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse name*</label>
                              <input type="text" maxLength="100" className="form-control" disabled value={storeName} onChange={_doSetStoreName} />
                              {storeName?.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter WareHouse Name</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse image</label>
                              <input  type="file" className="form-control"  onChange={(e) => setSelectedStoreFile(e.target.files[0])} accept={".png, .jpg, .jpeg"}/>
                              {/* {storeImage?.trim()=='' && isSubmit==true?<span className="text-danger">Please Select WareHouse Image</span>:null} */}
                            </div>
                          </div>
                          <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>GST number*</label>
                                <input type="text" maxLength="100" value={gstNumber} onChange={(e) => setGstNumber(e.target.value.replace(/[^\w\s]/gi, ""))} className="form-control" />
                                {gstNumber?.trim() == '' && isSubmit == true ? <span className="text-danger">Please Enter GST number</span> : null}
                              </div>
                            </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse address*</label>
                              <input type="text" maxLength="100" className="form-control" value={storeAddress} onChange={_doSelectStoreAddress} />
                              {storeAddress?.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter WareHouse Address</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Zone*</label>
                              <Select className="form-control"
                                showSearch
                                onChange={_doSelectZone}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={zone}
                              >
                                {
                                  ZoneList?.map((item =>
                                    <Option key={item.value} value={item.id}>{item.value}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>City*</label>
                              <Select className="form-control"
                                showSearch
                                onChange={_doSelectCity}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={city}
                              > {
                                  citiesList?.map((item =>
                                    <Option key={item.id} value={item.id}>{item.value}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>State*</label>
                              <Select className="form-control"
                                showSearch
                                onChange={_doSelectState}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={state}
                              > {
                                StateList?.map((item =>
                                    <Option key={item.id} value={item.id}>{item.value}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div>
                          {/* <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Property type*</label>
                              <Select className="form-control"
                                showSearch
                                onChange={_doSelectProperty}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={propertyType}
                              > {
                                  propertyTypes?.map((item =>
                                    <Option key={item.id} value={item.id}>{item.value}</Option>
                                  ))
                                }
                              </Select>
                            </div>
                          </div> */}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse status*</label>
                              <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked onChange={(status)=>setStoreStatus(status)} />
                            </div>
                          </div>
                        </div>
                        : ""
                    }
                    {
                      stepCount === 2 ?
                        <div className="row m-grid">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Landlord name*</label>
                              <input type="text" maxLength="100" className="form-control" value={landName} onChange={(e) => setLandName(e.target.value.replace(/[^\w\s]/gi, ""))} />
                              {landName?.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter Landlord Name</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Email ID*</label>
                              <input type="text" maxLength="100" className="form-control" value={email} onChange={_doSelectEmail} />
                              {(email?.trim()=='' || !validateEmail(email)) && isSubmit==true?<span className="text-danger">Please Enter Valid Email ID</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Contact number*</label>
                              <input type="text" maxLength="10" className="form-control" value={contactNumber} onChange={_doSelectContactNumber} />
                              {(`${contactNumber}`.length<10 ||`${contactNumber}`.length>10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Alternate number*</label>
                              <input type="text" maxLength="10" className="form-control" value={alternateNumber} onChange={_doSelectAlternateNumber} />
                              {(alternateNumber.length >0&&alternateNumber.length <10) && isSubmit == true ?<span className="text-danger">Please Enter Valid Mobile Number</span>:null }
                                
                              {/* {(`${alternateNumber}`.length<10 ||`${alternateNumber}`.length>10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null} */}
                            </div>
                          </div>
                          {propertyType !=="OWN" &&
                            <>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Lease start date*</label>
                              <DatePicker defaultValue={leaseStartDate.length ? dayjs(leaseStartDate):leaseStartDate} format={'YYYY-MM-DD'}  className="form-control" onChange={_doSelectLeaseStartDate} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Lease end date*</label>
                              <DatePicker className="form-control" defaultValue={leaseEndDate.length ? dayjs(leaseEndDate):leaseEndDate}  format={'YYYY-MM-DD'} onChange={_doSelectLeaseEndDate} />
                            </div>
                          </div>
                            </>
                          }
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse opening date*</label>
                              <DatePicker className="form-control" defaultValue={storeOpenDate.length ? dayjs(storeOpenDate): storeOpenDate}format={'YYYY-MM-DD'} onChange={_doSelectStoreOpenDate} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Warrenty/DLP end date*</label>
                              <DatePicker className="form-control" defaultValue={warrentyEndDate.length ?dayjs(warrentyEndDate):warrentyEndDate}format={'YYYY-MM-DD'}  onChange={_doSelectWarrentyEndDate} />
                            </div>
                          </div>
                        </div>
                        : ""
                    }

                    {
                      stepCount === 3 ?
                        <div className="row m-grid">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Sales area(In sqm)*</label>
                              <input type="number" className="form-control" value={salesArea} onChange={_doSelectSalesArea} />
                              {`${salesArea}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Sales Area</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Build up area (In sqm)*</label>
                              <input type="number" className="form-control" value={buildArea} onChange={_doSelectBuildArea} />
                              {`${buildArea}`.length==0  && isSubmit==true?<span className="text-danger">Please Enter Build Up Area</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Car parking*</label>
                              <select className="form-control m-form__input" value={carParking} onChange={_doSetCarParking}>
                                    <option>-- Please Select --</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                  </select>                           </div>
                          </div>
                          {/* {
                            carParking === "yes" ?
                              <div className="col-md-4">
                                <div className="form-group">
                                  <label htmlFor='exampleInput'>Select Separate/Combined*</label>
                                  <select className="form-control m-form__input" value={combined} onChange={_doSelectCombined}>
                                    <option>-- Please Select --</option>
                                    <option>Separate</option>
                                    <option>Combined</option>
                                  </select>
                                </div>
                              </div>
                              : ""
                          } */}
                         { carParking === "Yes" ?<div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>No. Of Car Parking Lots*</label>
                              <input type="number" className="form-control" value={carParkingNumber} onChange={_doSetCarParkingNumber} />
                              {`${carParkingNumber}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Car Parking Number</span>:null}
                            </div>
                          </div>:null}

                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>No. of two-wheeler parking lots*</label>
                              <input type="number" className="form-control" value={wheelerParking} onChange={_doSelectWeelerParking} />
                              {`${wheelerParking}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Number of Two-Wheeler Parking Lot</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>No. of stack parking*</label>
                              <input type="number" className="form-control" value={stackParking} onChange={_doSelectStackParking} />
                              {`${stackParking}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Number of Stack Parking</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Playground Concrete*</label>
                              <select className="form-control m-form__input" value={playground} onChange={(e)=>setPlayground(e.target.value)}>
                                    <option>-- Please Select --</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                  </select>
                              {playground?.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter PlayGround Details</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Size (In sqm)*</label>
                              <input type="number" className="form-control" value={size} onChange={(e)=>setSize(e.target.value)} />
                              {`${size}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter PlayGround Size</span>:null}

                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Playground (Turf)*</label>
                              <select className="form-control m-form__input" value={playgroundTurf} onChange={(e)=>setPlaygroundTurf(e.target.value)}>
                                    <option>-- Please Select --</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                              </select>
                              {playgroundTurf?.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter PlayGround Turf Details</span>:null}
   
                            </div>
                          </div>
                          {playgroundTurf=='Yes'? <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Size (In sqm)*</label>
                              <input type="number" className="form-control" value={playgroundTurfSize} onChange={(e)=>setPlaygroundTurfSize(e.target.value)} />
                              {`${playgroundTurfSize}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter PlayGround Turf Size</span>:null}
                            </div>
                          </div>:null}
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Maintenance Split List*</label>
                              <input  type="file" className="form-control"  onChange={(e) => setSelectedMaintenanceFile(e.target.files[0])} accept={".xls, .xlsx"}/>
                              {storeMaintenanceImage?.trim()=='' && isSubmit==true?<span className="text-danger">Please Select  File</span>:null}
                            
                            </div>
                          </div>
                        </div>
                        : ""
                    }
                    {
                      stepCount === 4 ?
                        <div className="row m-grid">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse operations Referent*</label>
                              <Select className="form-control"
                                showSearch
                                disabled
                                onChange={(value)=>setStoreOpRefId(value)}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={storeOpRefId}
                              > {
                                StoreOperationalList?.map((item =>
                                    <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                  ))
                                }
                              </Select> 
                               </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>SOR mobile number*</label>
                              <input type="text" maxLength="10" className="form-control" value={storeOperationsNumber} onChange={_doSelectStoreOperationsNumber} />
                              {(`${storeOperationsNumber}`.length>10 || `${storeOperationsNumber}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter  Mobile Number</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse leader*</label>
                              <Select className="form-control"
                                showSearch
                                disabled
                                onChange={(value)=>setStoreMgrId(value)}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={storeMgrId}
                              > {
                                StoreLeaderList?.map((item =>
                                    <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                  ))
                                }
                              </Select>
                              </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>WareHouse leader mobile number*</label>
                              <input type="text" maxLength="10" className="form-control" value={storeLeaderNumber} onChange={_doSelectStoreLeaderNumber} />
                              {(`${storeLeaderNumber}`.length>10 || `${storeLeaderNumber}`.length<10) && isSubmit==true?<span className="text-danger">Please Valid Mobile Number</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Zone operation maintenance coach name*</label>
                              <Select className="form-control"
                                showSearch
                                disabled
                                onChange={(value)=>setZoneOpCoachId(value)}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={zoneOpCoachId}
                              > {
                                ZonalManagerList?.map((item =>
                                    <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                  ))
                                }
                              </Select>       
                               </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Zone operation maintenance coach mobile number*</label>
                              <input type="text" maxLength="10" className="form-control" value={zoneOperationNumber} onChange={_doSelectZoneOperationNumber} />
                              {(`${zoneOperationNumber}`.length>10 || `${zoneOperationNumber}`.length<10) && isSubmit==true?<span className="text-danger">Please Valid Mobile Number</span>:null}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Construction manager name*</label>
                              <Select className="form-control"
                                showSearch
                                disabled
                                onChange={(value)=>setConstructionMgrId(value)}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={constructionMgrId}
                              > {
                                StoreOperationalList?.map((item =>
                                    <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                  ))
                                }
                              </Select>       
                              </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Construction manager mobile number*</label>
                              <input type="text" maxLength="10"className="form-control" value={constructionManagerNumber} onChange={(e)=>SetConstructionManageNumber(e.target.value.replace(/[^0-9]/g,''))} />
                              {(`${constructionManagerNumber}`.length>10 || `${constructionManagerNumber}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Maintance leader name*</label>
                              {/* <input type="text" className="form-control" value={maintainceLeader} onChange={(e)=>setMaintainceLeader(e.target.value)} /> */}
                              <Select className="form-control"
                                showSearch
                                disabled
                                onChange={(value)=>setMaintainceLeaderId(value)}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                value={maintainceLeaderId}
                              > {
                                StoreOperationalList?.map((item =>
                                    <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                  ))
                                }
                              </Select>       
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Maintance leader mobile number*</label>
                              <input type="text" maxLength="10" className="form-control" value={maintainceLeaderNumber} onChange={_doSelectMaintainceLeaderNumber} />
                              {(`${maintainceLeaderNumber}`.length>10 || `${maintainceLeaderNumber}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                            </div>
                          </div>
                        </div>
                        : ""
                    }

                    <div className="row">
                      <div className="col-md-12 text-right">
                        <div className="m-page__button top-space">
                          {
                            stepCount > 1 ?
                              <button type='button' onClick={_doPrevAction} className='btn muted-button  deca-btn-orange'>Prev</button>
                              : ""
                          }
                          {
                            stepCount < 4 ?
                              <button type='button' onClick={_doNextAction} className='btn btn-secondary deca-btn-yellow'>Next</button>
                              : ""
                          }
                              <button type='button' className='btn muted-button  deca-btn-yellow' onClick={handleSubmit}>Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-right">
              <div className="m-page__button top-space">
                <button type='button' onClick={_doNavToStoreList} className='btn muted-button deca-btn-orange'>Back</button>
              </div>
            </div>
          </div>
        </section>
      </div>)}
      <Footer />
    </div>
  )

}

